export var getEasing = function getEasing(props) {
  return props.theme.easing;
};